<template>
  <div class="wapper">
    <div class="query-wapper">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="发票信息编号"
                    v-model="query.invoiceApplyCode"></el-input>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="发票抬头"
                    v-model="query.customerInvoiceName"></el-input>
        </el-col>

        <el-col :span="6">
          <el-input placeholder="关联订单号"
                    v-model="query.orderNo"></el-input>

        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <Select :type="'OrderTypeNewEnum'"
                  :placeholder="'订单类型'"
                  @change="change"></Select>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="归属人"
                    v-model="query.ownerUserName"></el-input>
        </el-col>
      </el-row>
      <div class="button-wapper">
        <el-button plain
                   size='mini'
                   @click="getInfoList(undefined)">查询</el-button>
        <el-button plain
                   size='mini'
                   @click="reset">重置</el-button>
        <el-button plain
                   v-auth="'export'"
                   size='mini'
                   @click="exportInvoice"
                   type="primary">导出开票</el-button>
      </div>
    </div>
    <div class="content-wapper">
      <el-table :data="infos"
                size='mini'
                :border="true">
        <el-table-column prop="invoiceApplyCode"
                         width="150"
                         label="申请编号"></el-table-column>
        <el-table-column prop="customerInvoiceName"
                         width="150"
                         label="发票抬头"></el-table-column>
        <el-table-column prop="totalApplyInvoice"
                         label="开票总额"></el-table-column>
        <el-table-column prop="stateName"
                         label="开票状态"></el-table-column>
        <el-table-column prop="countApplyInvoice"
                         label="开票数量"></el-table-column>
        <el-table-column prop="ownerUserName"
                         label="归属人"></el-table-column>

        <el-table-column prop="gmtCreate"
                         width="200"
                         label="申请时间"></el-table-column>
        <el-table-column label="操作"
                         width="260">
          <template slot-scope="scope">
            <el-button @click="getDetail(scope.row)"
                       type="text"
                       v-auth="'view'"
                       size="small">查看</el-button>

            <el-button @click="confirmInvoice(scope.row)"
                       type="text"
                       size="small">立即开票</el-button>
            <el-button @click="cancel(scope.row)"
                       type="text"
                       v-if="scope.row.state==4 || scope.row.state==5 || scope.row.state==7 "
                       size="small">作废发票</el-button>

          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination :current-page.sync="query.pageIndex"
                     :page-size="query.pageSize"
                     @current-change="handleCurrentChange"
                     class="pagation"
                     layout="prev, pager, next, jumper"
                     :total="query.total">
      </el-pagination>
    </div>
    <!-- 添加合约公司 -->
    <addInvoiceCompany ref="addInvoiceCompany"
                       @refresh="getInfoList"></addInvoiceCompany>
    <el-dialog title="立即开票"
               :visible.sync="dialogVisible"
               width="60%">
      <el-table :data="tableData">
        <el-table-column prop="invoiceInfoCode"
                         label="开票信息编号">
        </el-table-column>
        <el-table-column prop="companyName"
                         label="开票公司">
        </el-table-column>
        <el-table-column prop="invoiceTypeName"
                         label="发票类型">
        </el-table-column>
        <el-table-column prop="totalInvoice"
                         label="开票总金额">
        </el-table-column>
        <el-table-column prop="drawerName"
                         label="开票人">
        </el-table-column>
        <el-table-column label="发票编号">
          <template slot-scope="scope">
            <el-input onkeyup="this.value=this.value.replace(/[\u4E00-\u9FA5]/g,'')"
                      v-model="scope.row.invoiceCode"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="作废发票"
               :visible.sync="cancelDialogVisible"
               width="40%">
      <span>提交后已开发票信息将作废，已开发票金额将回滚至原始订单的剩余可开票金额中，是否确认作废？</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="cancelSubmit">确定作废</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _tax from '@/service/tax-service'
import Select from '@/views/common/Select'
import _invoiceCompany from '@/service/invoice-company-service'
import _constant from '@/utils/constant'
import addInvoiceCompany from '@/views/invoice/company/add-invoice-company'
export default {
  components: {
    addInvoiceCompany,
    Select
  },

  data () {
    return {
      cancelDialogVisible: false,
      dialogVisible: false,
      invoiceId: null,
      tableData: null,
      infos: null,
      states: null,
      query: {
        invoiceApplyCode: null,
        customerInvoiceName: null,
        ownerUserName: null,
        state: null,
        orderNo: null,
        orderType: null,
        pageIndex: 1,
        pageSize: 20,
        total: 0

      }
    }
  },
  mounted () {
    this.getInfoList()
    // 状态
    this.states = _constant.states
  },
  methods: {
    cancelSubmit () {
      _tax.cancelInvoiceData(
        { id: this.invoiceId },
        (response) => {
          this.getInfoList()
          this.cancelDialogVisible = false

        }, response => {
          this.$notify({
            message: response,
            type: 'warning'
          })
        })
    },
    //作废发票
    cancel (row) {
      this.invoiceId = row.id
      this.cancelDialogVisible = true
    },
    //导出
    exportInvoice () {
      if (this.query.orderNo) {
        if (!this.query.orderType) {
          this.$message({
            message: '请选择订单类型'
          });
          return false
        }
      }
      _tax.exportInvoiceData(
        this.query,
        (response) => {
          window.location.href = response.request.responseURL


        }, response => {
          this.$notify({
            message: response,
            type: 'warning'
          })
        })
    },

    submit () {
      let query = []
      this.tableData.forEach(item => {
        query.push({
          id: item.id,
          invoiceCode: item.invoiceCode
        })


      })

      _tax.confirmInvoice(
        query,
        (response) => {
          this.getInfoList()
          this.dialogVisible = false

        }, response => {
          this.$notify({
            message: response,
            type: 'warning'
          })
        })

    },
    confirmInvoice (row) {
      _tax.getInvoiceBaseList(
        { invoiceApplyId: row.id },
        (response) => {
          this.tableData = response
          this.tableData.forEach(item => {
            item.totalInvoice = this.$numberUtils.divide(Number(item.totalInvoice), 100)

          })
          this.dialogVisible = true

        })


    },

    change (val, label, type) {
      if (type == 'InvoiceManageStateEnum') {
        this.query.state = val
      }
      if (type == 'OrderTypeNewEnum') {
        this.query.orderType = val
      }
    },
    getInfoList (pageIndex) {
      if (this.query.orderNo) {
        if (!this.query.orderType) {
          this.$message({
            message: '请选择订单类型'
          });
          return false
        }
      }
      if (pageIndex)
        this.query.pageIndex = pageIndex
      else
        this.query.pageIndex = 1
      _tax.toBeInvoiced(
        this.query,
        (response, total) => {
          // 请求成功
          this.infos = response
          this.infos.forEach((item, index) => {
            this.infos[index].totalApplyInvoice = this.$numberUtils.divide(Number(item.totalApplyInvoice), 100)

          })
          this.query.total = total
        })
    },
    handleCurrentChange (pageIndex) {
      this.getInfoList(pageIndex)
    },
    add () {
      this.$router.push({
        path: '/invoice-manage-add'
      })
    },
    getDetail (row) {
      this.$saveParams(this.query)
      this.$router.push({
        path: '/to-beInvoiced-detail?id=' + row.id
      })
    },
    edit (row) {
      this.$saveParams(this.query)
      this.$router.push({
        path: '/invoice-manage-add',
        query: {
          id: row.id
        }
      })
      // this.$refs.addInvoiceCompany.show(row.id)
    },
    reset () {
      location.reload()

    },
    updateContractCompanyState (rows) {
      _invoiceCompany.updateContractCompanyState(rows.id, rows.state, () => {
        this.$notify({
          message: '修改成功',
          type: 'success'
        });
      })
    }
  }
}
</script>

<style scoped>
.wapper {
  padding: 15px;
}
.header {
  margin-bottom: 15px;
}
.query-wapper {
  margin: 15px;
  padding: 15px;
  border: 1px solid #d6dbe5;
  position: relative;
  background: #fff;
}
.query-wapper::after {
  position: absolute;
  content: "筛选条件";
  top: -9px;
  color: #909399;
  background-color: #fbfbfb;
}
.content-wapper {
  padding: 0 15px;
  padding-bottom: 30px;
}
.button-wapper {
  margin-top: 10px;
}
.el-row {
  margin-bottom: 15px;
}
</style>